import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    desktopContainer: {
      marginBottom: 20,
      gap: 16,
      '@media (max-width: 1180px)': {
        display: 'none',
      },
    },
    formControl: {
      width: '100%',
      margin: 0,
    },
    filters: {
      flexGrow: 0,
      maxWidth: '18%',
      flexBasis: '18%',
    },
    emailField: {
      flexGrow: 0,
      maxWidth: '34%',
      flexBasis: '34%',
    },
    btnContainer: {
      flexGrow: 0,
      maxWidth: '10%',
      flexBasis: '10%',
    },
    mobileContainer: {
      '@media (min-width: 1181px)': {
        display: 'none',
      },
    },
    option: {
      '& span': {
        marginInlineStart: 20,
      },
      '& svg path': {
        stroke: variables.black10,
      },
    },
    selectedOption: {
      '& svg path': {
        stroke: variables.richBlack,
      },
      '& span': {
        marginInlineStart: 20,
      },
    },
    dialog: {
      width: 343,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
    },
    formControlLabel: {
      paddingTop: 20,
      paddingBottom: 20,
      marginRight: 5,
      display: 'inline-block',
    },
    divider: {
      width: 1,
      color: variables.black10,
    },
    groupBy: {
      flexGrow: 0,
      maxWidth: '32%',
      flexBasis: '32%',
    },
  }),
);
